<template>
  <div>
    <!-- 筛选 -->
    <div style="margin-bottom:10px;display:flex">
      <!-- 选择目的地 -->
      <select-dest placeholder="所属目的地"
                   :selectInputWidth="120"
                   @selectDest="selectDest"></select-dest>
      <!-- 选择模式 -->
      <div style="margin-left:10px">
        <el-radio-group v-model="trip_type"
                        size="mini">
          <el-radio-button label="1">抵达</el-radio-button>
          <el-radio-button label="2">整日</el-radio-button>
          <el-radio-button label="3">离开</el-radio-button>
          <el-radio-button label="4">中转</el-radio-button>
        </el-radio-group>
      </div>
      <!-- 模式 -->
      <div style="margin-left:10px">
        <el-radio-group v-model="trip_mode"
                        size="mini">
          <el-radio-button label="1">探索模式</el-radio-button>
          <el-radio-button label="2">自驾/租车</el-radio-button>
          <el-radio-button label="3">拼团</el-radio-button>
        </el-radio-group>
      </div>
      <!-- 搜索 -->
      <el-input size="mini"
                style="width:25%;margin-left:10px"
                placeholder="请输入迹点"
                v-model="searchContentKeyword"
                clearable>
        <el-button slot="append"
                   @click="searchButton"
                   icon="el-icon-search"></el-button>
      </el-input>
    </div>

    <!-- 列表 -->
    <el-table :data="dayTripData"
              v-loading='dayTripList_loadeing'
              :header-cell-style="courseRowClass"
              style="width: 100%">
      <el-table-column prop="trip_id"
                       label="ID"
                       align="center"
                       width="40">
      </el-table-column>
      <el-table-column prop="dest"
                       label="目的地"
                       align="center"
                       width="80">
        <template slot-scope="dest">
          <span style="color:#163AF3"
                v-if="dest.row.trip_type=='1'">抵达</span>
          <span style="color:green"
                v-if="dest.row.trip_type=='3'">离开</span>
          {{dest.row.dest}}
          <span style="color:#FFC300"
                v-if="dest.row.trip_type=='4'">中转</span>
          <span style="color:#ff5421"
                v-if="dest.row.trip_type=='2'">整日</span>
        </template>
      </el-table-column>

      <el-table-column prop="date"
                       label="旅行模式"
                       align="center"
                       width="90">
        <template slot-scope="item">
          <!-- 方式标签 -->
          <el-tag size="mini"
                  v-if="item.row.trip_mode=='1'">
            <span>探索</span>
          </el-tag>
          <el-tag size="mini"
                  v-if="item.row.trip_mode=='2'">
            <span>自驾/包车</span>
          </el-tag>
          <el-tag size="mini"
                  v-if="item.row.trip_mode=='3'">
            <span> 拼团</span>
          </el-tag>

        </template>

      </el-table-column>
      <el-table-column prop="recommend_time"
                       width="80"
                       label="建议出发">
      </el-table-column>
      <el-table-column show-overflow-tooltip
                       label="日行程包含">
        <template slot-scope="item">
          <div v-if="item.row.remark">
            <el-popover placement="top-start"
                        width="auto"
                        trigger="hover">
              <!-- 日行程说明 -->
              <div style="font-size:6px">行程说明：{{item.row.remark}}</div>
              <!-- 日行程概况 -->
              <div style="color:#ff5421"
                   slot="reference">
                <span v-for="traver,index in item.row.traver_list"
                      :key="index">{{traver.name}}
                  <span v-show="item.row.traver_list.indexOf(traver)!==item.row.traver_list.length-1"> -> </span>
                </span>
              </div>
            </el-popover>
          </div>
          <!-- 没有行程说明 -->
          <div v-else>
            <div style="color:#ff5421">
              <span v-for="traver,index in item.row.traver_list"
                    :key="index">{{traver.name}}
                <span v-show="item.row.traver_list.indexOf(traver)!==item.row.traver_list.length-1"> -> </span>
              </span>
            </div>
          </div>

          <div class="weekend-style-day-trip">可选：

            <span style="margin-left:5px"
                  v-for="i,index in item.row.running_week"
                  :key="index">
              <span v-if="i=='1'">周一</span>
              <span v-else-if="i=='2'">周二</span>
              <span v-else-if="i=='3'">周三</span>
              <span v-else-if="i=='4'">周四</span>
              <span v-else-if="i=='5'">周五</span>
              <span v-else-if="i=='6'">周六</span>
              <span v-else-if="i=='0'">周日</span>

            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="120"
                       align="center"
                       label="操作">
        <template slot-scope="item">
          <el-button-group>
            <el-button type="primary"
                       size="mini"
                       icon="el-icon-plus"
                       @click="addDayTripToTraverlPlan(item.row.trip_id)"
                       circle></el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <!-- ----------------- 分页 ------------------ -->
    <div class="pagination">
      <el-pagination @current-change="handleCurrentChange_system"
                     :small="true"
                     background
                     layout="prev, pager, next,total"
                     :current-page.sync="pagenum_system"
                     :page-size="pagesize"
                     :total="page_account"></el-pagination>
    </div>
  </div>
</template>

<script>
import SelectDest from '../../components/common/select/SelectDest'

export default {
  name: 'select-day-trip-list',
  components: {
    SelectDest,
  },
  data() {
    return {
      dayTripList_loadeing: false,
      // 筛选
      dest: '',
      traver_id: '',
      trip_type: '',
      trip_mode: '',
      recommend_time: '',
      searchContentKeyword: '',
      // 列表
      dayTripData: [],
      // 列表
      pagenum_system: 1,
      pagesize: 10,
      page_account: null,
    }
  },
  watch: {
    dayTripListLoadeing(newVal) {
      this.dayTripList_loadeing = newVal
    },
  },
  props: {
    dayTripListLoadeing: false,
  },
  mounted() {
    this.getDayTripList()
  },
  methods: {
    // 选择日行程
    addDayTripToTraverlPlan(trip_id) {
      // console.log(day_trip_id)
      // 将日行程id ，传出
      this.$emit('getDayTripDate', trip_id)
    },
    // 选择目的地
    selectDest(value) {
      if (value !== null) {
        this.dest = value
      } else {
        this.dest = ''
      }
    },
    // 表头的样式
    courseRowClass() {
      return 'background-color:whitesmoke; '
    },
    // 分页
    handleCurrentChange_system(page_num) {
      this.pagenum_system = page_num
      this.getDayTripList()
    },
    // 搜索日行程
    searchButton() {
      this.getDayTripList()
    },
    // 获取日行程列表
    getDayTripList() {
      this.dayTripList_loadeing = true
      this.$http
        .get(
          `/traver/get_day_trip_list?p_num=${this.pagenum_system}&p_size=${this.pagesize}&dest=${this.dest}&traver_id=${this.traver_id}&trip_type=${this.trip_type}&trip_mode=${this.trip_mode}&recommend_time=${this.recommend_time}&key_word=${this.searchContentKeyword}`
        )
        .then((res) => {
          // console.log(res)
          if (res.data.errno == '0') {
            this.dayTripData = res.data.data
            this.page_account = res.data.total
            this.dayTripList_loadeing = false
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'console.error();',
            })
          }
        })
    },
  },
}
</script>

<style>
.pagination {
  text-align: right;
  margin-top: 10px;
}
</style>